import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './lib/theme';
import { AuthProvider, RequireAuth } from './lib/auth';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Receipts from './pages/Receipts';
import ReceiptDetail from './pages/ReceiptDetail';
import ExportPage from './pages/Reporting';
import SettingsPage from './pages/Settings';
import Inbox from './pages/Inbox';
import Bookkeeper from './pages/Bookkeeper';
import TaxReady from './pages/TaxReady';
import Cleo from './pages/Cleo';
import Support from './pages/Support';
import Landing from './pages/Landing';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import QuickBooksCallback from './pages/QuickBooksCallback';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            {/* Phase 23 — Stripe post-checkout. Public because the user may
                hit them before AuthProvider has rehydrated from localStorage
                after the Stripe redirect. */}
            <Route path="/billing/success" element={<CheckoutSuccess />} />
            <Route path="/billing/cancel" element={<CheckoutCancel />} />
            {/* Phase 25 — Safety-net frontend route; the actual QuickBooks
                OAuth exchange runs server-side on /api/quickbooks/callback. */}
            <Route path="/quickbooks/callback" element={<QuickBooksCallback />} />

            {/* Admin — role-guarded */}
            <Route
              path="/admin"
              element={
                <RequireAuth role="admin">
                  <AdminDashboard />
                </RequireAuth>
              }
            />

            {/* App — any authenticated user */}
            <Route
              path="/app"
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="receipts" element={<Receipts />} />
              <Route path="receipts/:id" element={<ReceiptDetail />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="bookkeeper" element={<Bookkeeper />} />
              <Route path="tax-ready" element={<TaxReady />} />
              <Route path="reporting" element={<ExportPage />} />
              <Route path="cleo" element={<Cleo />} />
              <Route path="support" element={<Support />} />
              <Route path="export" element={<Navigate to="/app/reporting" replace />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            {/* Legacy redirects — keep deep links working */}
            <Route path="/dashboard" element={<Navigate to="/app" replace />} />
            <Route path="/receipts/*" element={<Navigate to="/app/receipts" replace />} />
            <Route path="/bookkeeper" element={<Navigate to="/app/bookkeeper" replace />} />
            <Route path="/tax-ready" element={<Navigate to="/app/tax-ready" replace />} />
            <Route path="/reporting" element={<Navigate to="/app/reporting" replace />} />
            <Route path="/cleo" element={<Navigate to="/app/cleo" replace />} />
            <Route path="/support" element={<Navigate to="/app/support" replace />} />
            <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
            <Route path="/inbox" element={<Navigate to="/app/inbox" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
